import {
	Grid
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { memo, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import strings from '../../Globalization/index';
import { useModelForm } from '../../contexts/ModelForm';
import Accordion from '../common/Accordion';
import FormGroupInputs from './FormGroupInputs';

const AccordionFormGroup = ({
	expanded,
	onChange,
	formGroup,
	customizeFormGroup: FormGroupComponent = Accordion,
	id,
	formGroupIndex
}) => {
	const location = useLocation();
	const theme = useTheme();

	const { formik, activeRecord } = useModelForm();
	const { visible, accordionProps } = useMemo(() => {
		const visibleVal =
			'visible' in formGroup
				? typeof formGroup?.visible === 'function'
					? formGroup.visible({ formik, activeRecord, formGroup, location })
					: Boolean(formGroup?.visible)
				: true;
		const accordionPropsVal =
			typeof formGroup.accordionProps === 'function'
				? formGroup.accordionProps({ formik, activeRecord, location })
				: formGroup.accordionProps;
		return { visible: visibleVal, accordionProps: accordionPropsVal };
	}, [formik.values, activeRecord, formGroup, location]);

	return (
		visible && (
			<FormGroupComponent
				expanded={expanded}
				onChange={onChange}
				title={strings[formGroup.header] || formGroup.alternateHeader || formGroup.header}
				id={id}
				{...accordionProps}
			>
				{expanded && (
					<Grid
						container
						sx={{
							paddingTop: theme.spacing(1),
							'& .formGroupInputWrapper': { display: 'flex', alignItems: 'center' }
						}}
						spacing={3}
						{...formGroup.containerProps}
					>
						{Array.isArray(formGroup.inputs) && (
							<FormGroupInputs formGroup={formGroup} formGroupIndex={formGroupIndex} />
						)}
					</Grid>
				)}
			</FormGroupComponent>
		)
	);
};

const AccordionFormGroups = () => {
	const { formGroups, openFormGroupIndex, setOpenFormGroupIndex } = useModelForm();
	const handleOnChangeExpanded = useCallback(
		(index) => () => {
			setOpenFormGroupIndex(index);
		},
		[setOpenFormGroupIndex]
	);
	return (
		<Grid
			container
			sx={{
				'& .MuiTabScrollButton-root.Mui-disabled': {
					opacity: 0.3
				}
			}}
		>
			<Grid size={12}>
				{formGroups.map((formGroup, i) => (
					<AccordionFormGroup
						expanded={!!(openFormGroupIndex === i || openFormGroupIndex?.includes?.(i) || formGroup.expanded)}
						onChange={handleOnChangeExpanded(i)}
						formGroup={formGroup}
						id={`form-group-${i}`}
						formGroupIndex={i}
						key={`form-group-accordion-${i}`}
					/>
				))}
			</Grid>
		</Grid>
	);
};

export default memo(AccordionFormGroups);
